import { AxiosRequestConfig } from 'axios';
import HTTP from 'libs/HTTP';
import { EnumLanguageClient, EnumLanguageCode } from 'models/language';
import { EnumTaskStatus } from 'models/uploadTask';

class UploadTask extends HTTP {
  config: AxiosRequestConfig = {
    baseURL: this.config.baseURL + '/ai-coach-manager-server/api'
  };

  // 下载上传任务中的错误信息
  async downloadErrorData(id: string) {
    return this.post(
      `/upload/task/download/errorData/${id}`,
      {},
      {
        responseType: 'blob'
      }
    );
  }

  // 上传任务列表
  async taskList(status: EnumTaskStatus) {
    return await this.post(`/upload/task/list?status=${status}`);
  }

  // 修改上传任务未读状态
  // 如果传id，则读取单条消息，如果传status，则将一种类型的消息全标已读
  async taskRead(params: { id?: string; status?: EnumTaskStatus }) {
    if (params.id) {
      return await this.post(`/upload/task/read?id=${params.id}`);
    } else {
      return await this.post(`/upload/task/read?status=${params.status}`);
    }
  }

  // 上传任务未读数量
  async unreadCount() {
    return await this.post(`/upload/task/unread/count`);
  }

  // 上传组织用户
  async uploadByOrg(data: any) {
    return this.post('/user/upload/byOrg', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
  // 上传数据角色用户
  async uploadByDataRole(data: any) {
    return this.post('/user/upload/byDataRole', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
  // 上传功能角色用户
  async uploadByFeatureRole(data: any) {
    return this.post('/user/upload/byFeatureRole', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
  // 上传学习小组用户
  async uploadByLearnTeam(data: any) {
    return this.post('/user/upload/byLearnTeam', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
  // 上传组织
  async importOrgs(data: any) {
    return this.post('/user/upload/org', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
  // 上传用户
  async importUsers2(data: any) {
    return this.post('/user/upload/add', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }

  /** 上传国际化文件 */
  async uploadI18n(data: any) {
    return this.post('/manager/language/upload', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
  /** 查询国际化配置 */
  async queryI18n(languageCode: EnumLanguageCode) {
    return this.get(`/manager/language/list`, {
      params: {
        languageCode: languageCode,
        languageClient: EnumLanguageClient.admin
      }
    });
  }
  /** 查询是否存在国际化excel上传记录 */
  async queryExistI18n() {
    return this.get(`manager/language/exist`);
  }
  /** 下载国际化文件 */
  async downloadI18n() {
    return this.post(
      `/manager/language/download`,
      {},
      {
        responseType: 'blob'
      }
    );
  }
}

const uploadTask = new UploadTask();
export default uploadTask;
